import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { API_GET_OPEN, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import { toast } from "react-toastify";

const validationSchema = Yup.object({
  content: Yup.string().required("Privacy Policy is required"),
  german: Yup.string().required("Privacy Policy is required"),
});

const PrivacyPolicy = () => {
  const ref = useRef();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    content: "",
    german: "",
  });

  const GetPrivacy = async () => {
    setLoading(true);
    try {
      const res = await API_GET_OPEN(API_endspoints.getprivacy);
      formik.setFieldValue("content", res?.r?.content);
      formik.setFieldValue("german", res?.r?.german);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    GetPrivacy();
  }, []);

  const formik = useFormik({
    initialValues: { content: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        const res = await API_POST(API_endspoints.updateprivacy, values);
        if (res.s) {
          toast.success("Updated Successfully");
        }
        setLoading(false);
        GetPrivacy();
      } catch (error) {
      } finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <Box>
      {loading ? (
        <Box className="flexCenter" sx={{ height: "calc(100vh - 200px)" }}>
          <CircularProgress />
        </Box>
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexDirection: { xs: "column", lg: "row" },
            }}
          >
            <Box
              sx={{
                color: "#000",
                width: "100%",
                textAlign: "left",
                borderRadius: "10px",
                boxSizing: "border-box",
                p: "2px",
                background: `rgba(234, 232, 255, 0.18)`,
                "& .ql-container": {
                  minHeight: "200px",
                  maxHeight: "calc(100vh - 300px)",
                  overflow: "auto",
                  resize: "both",
                  color: "#000",
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                  background: "#fff",
                },
                "& .ql-toolbar": {
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  zIndex: 999,
                  backgroundColor: "#fff",
                },
                "& .ql-toolbar .ql-picker": {
                  color: "#000",
                },
                "& .ql-toolbar button": {
                  color: "#000 !important", 
                },
                "& .ql-toolbar .ql-stroke": {
                  stroke: "#000", 
                },
                "& .ql-toolbar .ql-fill": {
                  color: "#000 !important",
                },
                "& .ql-toolbar .ql-picker-options": {
                  backgroundColor: "#fff", 
                  color: "#000", 
                },
                "& .ql-toolbar .ql-picker-label": {
                  color: "#000 !important", 
                },
                "& .ql-toolbar button:focus": {
                  backgroundColor: "#fff !important",
                  color: "#000 !important",
                },
                ".ql-editor.ql-blank::before": {
                  color: "#000",
                  fontWeight: "500",
                },
              }}
            >
              <ReactQuill
                placeholder="Privacy Policy"
                value={formik.values.content}
                ref={ref}
                onChange={(content) => {
                  content = content.replace(/(^<[^>]*>)([\s]*)/gm, "$1");
                  formik.setFieldValue("content", content);
                }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],

                    [
                      { align: "right" },
                      { align: "center" },
                      { align: "justify" },
                      { align: "" },
                    ],
                    [
                      {
                        color: [
                          "black",
                          "#D8D4FF",
                          "gray",
                          "silver",
                          "maroon",
                          "red",
                          "purple",
                          "green",
                          "lime",
                          "yellow",
                          "navy",
                          "blue",
                          "teal",
                          "aqua",
                        ],
                      },
                      {
                        background: [
                          "transparent",
                          "#f5f5f5", // Light Grey
                          "#dcdcdc", // Gainsboro
                          "#c0c0c0", // Silver
                          "#a9a9a9", // Dark Grey
                          "#808080", // Grey
                          "#696969", // Dim Grey
                          "#595959", // Dark Grey
                          "#404040", // Black
                          "#2f2f2f", // Dark Grey
                          "#202020", // Dark Grey
                          "#101010", // Black
                          "#ff0000", // Red
                          "#00ff00", // Green
                          "#0000ff", // Blue
                          "#000f00", // Yellow
                          "#ff00ff", // Magenta
                          "#00ffff", // Cyan
                          "#808080", // Gray
                          "#800080", // Purple
                          "#008000", // Green
                          "#000080", // Navy
                          "#808000", // Olive
                          "#ffa500", // Orange
                          "#ff69b4", // Pink
                          "#ffdab9", // Peach
                          "#fa8072", // Salmon
                          "#a52a2a", // Brown
                          "#008080", // Teal
                          "#00ffff", // Cyan
                          "#90ee90", // Light Green
                          "#ffb6c1", // Pink
                          "#000af0", // Floral White
                          "#000fe0", // Light Yellow
                        ],
                      },
                    ],
                  ],
                }}
                className="termsCondtionContent"
              />
              {formik.errors.privacy_policy && formik.touched.privacy_policy ? (
                <div>{formik.errors.privacy_policy}</div>
              ) : null}
            </Box>
            <Box
              sx={{
                color: "#000",
                width: "100%",
                textAlign: "left",
                borderRadius: "10px",
                boxSizing: "border-box",
                p: "2px",
                background: `rgba(234, 232, 255, 0.18)`,
                "& .ql-container": {
                  minHeight: "200px",
                  maxHeight: "calc(100vh - 300px)",
                  overflow: "auto",
                  resize: "both",
                  // backgroundColor: "transparent",
                  color: "#000",
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                  // backgroundcolor:'#000',
                  background: "#fff",
                },
                "& .ql-toolbar": {
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  zIndex: 999,
                  backgroundColor: "#fff",
                },
                "& .ql-toolbar .ql-picker": {
                  color: "#000", // Ensure dropdown pickers have white color
                },
                "& .ql-toolbar button": {
                  color: "#000 !important", // Ensure buttons have white color
                },
                "& .ql-toolbar .ql-stroke": {
                  stroke: "#000", // Ensure toolbar icons have white stroke color
                },
                "& .ql-toolbar .ql-fill": {
                  color: "#000 !important", // Ensure toolbar icons have white fill color
                },
                "& .ql-toolbar .ql-picker-options": {
                  backgroundColor: "#fff", // Adjust dropdown background for better contrast
                  color: "#000", // Ensure dropdown options have white color
                },
                "& .ql-toolbar .ql-picker-label": {
                  color: "#000 !important", // Ensure picker label has white color
                },
                "& .ql-toolbar button:focus": {
                  backgroundColor: "#fff !important", // Ensure focus background color
                  color: "#000 !important", // Ensure text color is white on focus
                },
                ".ql-editor.ql-blank::before": {
                  color: "#000",
                  fontWeight: "500",
                },
              }}
            >
              <ReactQuill
                placeholder="Privacy Policy"
                value={formik.values.german}
                ref={ref}
                onChange={(german) => {
                  german = german.replace(/(^<[^>]*>)([\s]*)/gm, "$1");
                  formik.setFieldValue("german", german);
                }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],

                    [
                      { align: "right" },
                      { align: "center" },
                      { align: "justify" },
                      { align: "" },
                    ],
                    [
                      {
                        color: [
                          "black",
                          "#D8D4FF",
                          "gray",
                          "silver",
                          "maroon",
                          "red",
                          "purple",
                          "green",
                          "lime",
                          "yellow",
                          "navy",
                          "blue",
                          "teal",
                          "aqua",
                        ],
                      },
                      {
                        background: [
                          "transparent",
                          "#f5f5f5", // Light Grey
                          "#dcdcdc", // Gainsboro
                          "#c0c0c0", // Silver
                          "#a9a9a9", // Dark Grey
                          "#808080", // Grey
                          "#696969", // Dim Grey
                          "#595959", // Dark Grey
                          "#404040", // Black
                          "#2f2f2f", // Dark Grey
                          "#202020", // Dark Grey
                          "#101010", // Black
                          "#ff0000", // Red
                          "#00ff00", // Green
                          "#0000ff", // Blue
                          "#000f00", // Yellow
                          "#ff00ff", // Magenta
                          "#00ffff", // Cyan
                          "#808080", // Gray
                          "#800080", // Purple
                          "#008000", // Green
                          "#000080", // Navy
                          "#808000", // Olive
                          "#ffa500", // Orange
                          "#ff69b4", // Pink
                          "#ffdab9", // Peach
                          "#fa8072", // Salmon
                          "#a52a2a", // Brown
                          "#008080", // Teal
                          "#00ffff", // Cyan
                          "#90ee90", // Light Green
                          "#ffb6c1", // Pink
                          "#000af0", // Floral White
                          "#000fe0", // Light Yellow
                        ],
                      },
                    ],
                  ],
                }}
                className="termsCondtionContent"
              />
              {formik.errors.privacy_policy && formik.touched.privacy_policy ? (
                <div>{formik.errors.privacy_policy}</div>
              ) : null}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mt: "15px",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              disabled={
                formik.isSubmitting ||
                !formik?.values?.content?.replace(/<[^>]+>/g, "").trim()
              }
              sx={{
                width: "150px",
                textTransform: "none",
                borderRadius: "8px",
                backgroundColor: "#164FA1",
                "&:hover": {
                  backgroundColor: "#164FA1",
                },
                "&:disabled": {
                  background: "gray", // Style for the disabled button
                },
              }}
            >
              {formik.isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        </form>
      )}
    </Box>
  );
};

export default PrivacyPolicy;
